import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.33341 1.51306V4.26676C9.33341 4.64012 9.33341 4.82681 9.40608 4.96942C9.46999 5.09486 9.57198 5.19684 9.69742 5.26076C9.84003 5.33342 10.0267 5.33342 10.4001 5.33342H13.1538M10.6667 8.66671H5.33341M10.6667 11.3334H5.33341M6.66675 6.00004H5.33341M9.33341 1.33337H5.86675C4.74664 1.33337 4.18659 1.33337 3.75877 1.55136C3.38244 1.74311 3.07648 2.04907 2.88473 2.42539C2.66675 2.85322 2.66675 3.41327 2.66675 4.53337V11.4667C2.66675 12.5868 2.66675 13.1469 2.88473 13.5747C3.07648 13.951 3.38244 14.257 3.75877 14.4487C4.18659 14.6667 4.74664 14.6667 5.86675 14.6667H10.1334C11.2535 14.6667 11.8136 14.6667 12.2414 14.4487C12.6177 14.257 12.9237 13.951 13.1154 13.5747C13.3334 13.1469 13.3334 12.5868 13.3334 11.4667V5.33337L9.33341 1.33337Z",
      stroke: "#23252C",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }